import React from 'react';

import useScreenOrientation from './helpers/useScreenOrientation';
import { BulletData } from "./../data/bullet.data";

export default function SoloViewBullet({ isVisible, isSidebarVisible, showActiveBullet, bulletSelected, setBulletSelected }: any) {

  //const [bulletSelected, setBulletSelected] = React.useState<any>(null);
  const [showComponent, setShowComponent] = React.useState(false);
  const [showAnimation, setShowAnimation] = React.useState(false);

  const isLandscape = useScreenOrientation();

  React.useEffect(() => {
    if (showActiveBullet) {
      const bulletData: any = BulletData();
      let foundBullet: any = null
      for (let bulletKey in bulletData) {
        for (const bullet of bulletData[bulletKey]) {
          if (bullet.id === showActiveBullet) {
            foundBullet = bullet;
            break;
          }
        }
        if (foundBullet)
          break;
      }
      if (foundBullet){
        setBulletSelected(foundBullet)
        setShowAnimation(true)
      }
    }
  }, [showActiveBullet, setBulletSelected]);

  React.useEffect(() => {
    if (isVisible === true) {
      setShowComponent(true)
    } else {
      setBulletSelected(null)
      setTimeout(() => { setShowComponent(false) }, 1000);
    }
  }, [isVisible, setBulletSelected]);

  const setLocalBulletSelected = (value: any) => {
    setShowAnimation(false)
    setTimeout(() => { setBulletSelected(value) }, 1000);
  };


  return (
    <div className={`full-soloviewbullet-container ${isVisible && showAnimation ? 'transition-fade-in' : 'transition-fade-out'}`}>
      {(showComponent && bulletSelected !== null) && <div className={`soloviewbullet-container-active`}>
        {isLandscape ?
          <div className={`soloviewbullet-container ${isSidebarVisible ? '' : 'expand'}`}>

            <div className={`soloviewbullet-container-background`}>
              <div className={`soloviewbullet-container-content`}>
                {/* <div className={`soloviewbullet-container-content-img`} style={{ backgroundImage: `url(${bulletSelected.image})` }}></div> */}
                {bulletSelected.title !== '' &&
                  <div className={`soloviewbullet-container-content-title`}>{bulletSelected.title}</div>
                }
                <div className={`soloviewbullet-container-content-desc`}>{bulletSelected.text}</div>
                <div className="soloviewbullet-button" onClick={() => setLocalBulletSelected(null)}>
                  <div className="soloviewbullet-button-text">
                    Cerrar
                  </div>
                </div>
              </div>
            </div>
          </div>
          :
          <div className={`soloviewbullet-container-portrait ${isSidebarVisible ? '' : 'expand'}`}>
            
            <div className={`soloviewbullet-container-background`}>
              <div className={`soloviewbullet-container-content`}>
                {/* <div className={`soloviewbullet-container-content-img`} style={{ backgroundImage: `url(${bulletSelected.image})` }}></div> */}
                {bulletSelected.title !== '' &&
                  <div className={`soloviewbullet-container-content-title`}>{bulletSelected.title}</div>
                }
                <div className={`soloviewbullet-container-content-desc`}>{bulletSelected.text}</div>
                <div className="soloviewbullet-button" onClick={() => setBulletSelected(null)}>
                  <div className="soloviewbullet-button-text">
                    Cerrar
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        }
      </div>
      }
    </div>
  );
}
